<!-- eslint-disable -->
<template>
	<div class="login-container"
		:style="removeBgbyWindowSize">
		<div class="bar"
			:style="{
				'background': colors.primary
			}"		
		></div>
		<div class="wrapper">
			<div class="logo">
				<div class="svg-logo" v-if="game == 'repense'">
					<LogoRepense></LogoRepense>
				</div>
				<div class="svg-logo" v-if="game == 'decode'">
					<!-- <img :src="image" alt=""> -->
					<LogoDecode></LogoDecode>
				</div>
				<div v-if="game != 'decode' && game != 'repense'" class="center-flex">
					<svg version="1.1" id="Layer_1" class="svg-logo-huddle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 610 610" xml:space="preserve">
						<path class="st0" fill="#1D2029" d="M540.25,605.25H70.11c-35.86,0-64.93-29.07-64.93-64.93V70.18c0-35.86,29.07-64.93,64.93-64.93h470.14
							c35.86,0,64.93,29.07,64.93,64.93v470.14C605.18,576.18,576.11,605.25,540.25,605.25z"/>
						<g>
							<path class="st1" fill="#02E5DA" d="M157.81,152.89h69.18v110.77c7.2-6.66,16.86-12.46,28.99-17.39c12.13-4.93,23.92-7.4,35.39-7.4
								c23.99,0,41.05,6.67,51.18,20c10.13,13.33,15.19,32.53,15.19,57.58V457.6h-69.18V325.64c0-8.53-2.34-14.8-7-18.79
								c-4.67-4-10.74-6-18.2-6c-6.67,0-13.13,1.34-19.39,4c-6.27,2.67-11.93,6-16.99,10V457.6h-69.18V152.89z"/>
							<g>
								<path class="st1" fill="#02E5DA" d="M489.23,457.6h-70.85l-77.85-304.71h70.78L489.23,457.6z"/>
							</g>
						</g>
					</svg>
				</div>
			</div>		
			<div class="program_info">
				<div class="slogan" 
					:style="{
						color: colors.primary
					}"
				>{{ workspaceTitle }}</div>
			</div>				
			<!-- <div class="cadastro" v-if="!noRegisterWorkspaces.includes(workspaceId)">
				<router-link to="/register-email">
					<button-outline
						:text="$t('components.FormLogin.button_outline1_text')"
					></button-outline>
				</router-link>
			</div> -->
			<div class="methods-login">
				<div class="form-login-email">
					<form class="form" @submit.prevent="loginEmailPassword()">
						<input-default type="e-mail" name="email" placeholder="e-mail"></input-default>
						<input-default
							type="password"
							name="password"
							:placeholder="$t('components.FormLogin.input_pass_placeholder')"
						></input-default>
						<div class="container-button">
							<button
								class="button-default "

								:style="{
									color: colors.theme !== 'dark' ? '#000' : '#fff',
									background: colors && colors.secondary,
									borderTop: colors && `7px solid ${colors.secondary}`,
									borderBottom: `none`
								}"
							>
								{{ $t("components.FormLogin.button_login") }}
							</button>
						</div>					
					</form>
						<div class="container-button">
							<router-link to="/forgot-pass">
								<button class="button-default secondary"
									:style="{
										color: colors.theme !== 'dark' ? '#000' : '#fff',
										background: 'transparent',
										border: colors.theme !== 'dark' ? '1px solid #000' : '1px solid #fff',
									}"						
								>{{ $t('components.FormLogin.button_outline2_text') }}</button>
							</router-link>
							<!-- <router-link to="/forgot-pass">
							</router-link> -->
						</div>							
				</div>
				<!-- <div class="copyright"
				 	v-if="game !== 'repense'"
					:style="{
						color: colors.theme !== 'dark' ? '#000' : '#fff',
						fill: colors.theme !== 'dark' ? '#000' : '#fff'
					}"				
				>
					<span>{{ $t("views.AccessOption.copyright") }}</span>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.88 50.23"><defs></defs><g id="Camada_2" data-name="Camada 2"><g id="Layer_1" data-name="Layer 1"><path :fill="colors.logoHuddle" class="cls-1" d="M0,.07H11.3V18.16A15.35,15.35,0,0,1,16,15.32a15.18,15.18,0,0,1,5.78-1.21q5.87,0,8.36,3.26t2.48,9.41V49.84H21.36V28.28a3.85,3.85,0,0,0-1.14-3.07,4.46,4.46,0,0,0-3-1,7.89,7.89,0,0,0-3.16.66,12,12,0,0,0-2.78,1.63V49.84H0Z"/><path :fill="colors.logoHuddle" class="cls-1" d="M98.7,32.66a38.75,38.75,0,0,1,1.21-10.75,13.35,13.35,0,0,1,.51-1.39V0H89.12V15.61a25.81,25.81,0,0,0-8.36-1.5c-3.4,0-6,.63-7.94,1.89a10.46,10.46,0,0,0-4,5.91,38.75,38.75,0,0,0-1.21,10.75q0,9.41,3.14,13.49t9.4,4.08a12,12,0,0,0,4.77-1,16.43,16.43,0,0,0,4.25-2.65l1.76,3.27h9.54V43.65A28.83,28.83,0,0,1,98.7,32.66Zm-9.58,6.92a8.55,8.55,0,0,1-5,1.63A5.91,5.91,0,0,1,81,40.5a4.24,4.24,0,0,1-1.6-2.65,25.61,25.61,0,0,1-.49-5.78,24.27,24.27,0,0,1,.56-6,4.55,4.55,0,0,1,1.73-2.77,6.34,6.34,0,0,1,3.4-.76,10.34,10.34,0,0,1,4.57,1.25Z"/><path :fill="colors.logoHuddle" class="cls-1" d="M158.48,49.85H146.92L134.21,0h11.56Z"/><path :fill="colors.logoHuddle" class="cls-1" d="M169.81,41.28a3.91,3.91,0,0,1-2.38-1.7,7.72,7.72,0,0,1-.82-3.4h7.51q5.74,0,8.75-2.22t3-7.51a16.32,16.32,0,0,0-1.41-7.54,7.68,7.68,0,0,0-4.53-3.72,27.7,27.7,0,0,0-8.69-1.08c-4.1,0-7.26.53-9.51,1.6a9.48,9.48,0,0,0-4.83,5.48,25,25,0,0,0-1.3,6.59l5.11,20a9.75,9.75,0,0,0,1.38.77q3.47,1.57,9.61,1.57a46.64,46.64,0,0,0,6.89-.45,53.25,53.25,0,0,0,6-1.31V41.8h-9.86A17.87,17.87,0,0,1,169.81,41.28Zm-2.28-17.54q1-1.53,3.72-1.53a5.28,5.28,0,0,1,3.62,1A4.32,4.32,0,0,1,176,26.52a3.11,3.11,0,0,1-.72,2.32,3.37,3.37,0,0,1-2.35.68h-6.4C166.48,26.69,166.83,24.77,167.53,23.74Z"/><path :fill="colors.logoHuddle" class="cls-1" d="M131.44,0h-8.35V15.61a25.81,25.81,0,0,0-8.36-1.5q-5.1,0-7.94,1.89a10.46,10.46,0,0,0-4.05,5.91,38.37,38.37,0,0,0-1.21,10.75q0,9.41,3.14,13.49t9.4,4.08a12.06,12.06,0,0,0,4.77-1,16.6,16.6,0,0,0,4.25-2.65l1.76,3.27h9.54V11.54Zm-8.35,39.58a8.58,8.58,0,0,1-5,1.63,5.91,5.91,0,0,1-3.2-.71,4.24,4.24,0,0,1-1.6-2.65,25,25,0,0,1-.49-5.78,24.27,24.27,0,0,1,.56-6,4.51,4.51,0,0,1,1.73-2.77,6.3,6.3,0,0,1,3.39-.76,10.34,10.34,0,0,1,4.58,1.25Z"/><path :fill="colors.logoHuddle" class="cls-1" d="M64.68,32.66a38.37,38.37,0,0,1,1.21-10.75c.13-.42.27-.82.43-1.21v-6H55.09V38a9.18,9.18,0,0,1-2.81,1.64,8.82,8.82,0,0,1-3.07.65A4.78,4.78,0,0,1,46,39.39,4.12,4.12,0,0,1,45,36.12V14.7H33.66v3.86a17,17,0,0,1,1.72,8.22V46.19a8.77,8.77,0,0,0,.93,1.2,9.47,9.47,0,0,0,7.28,2.84q5.35,0,11.5-3.86L57,49.84h9.34V43.46A29.19,29.19,0,0,1,64.68,32.66Z"/></g></g></svg>
				</div> -->
				<div class="copyright"
					:style="{
						color: colors.theme !== 'dark' ? '#000' : '#fff',
						fill: colors.theme !== 'dark' ? '#000' : '#fff'
					}"				
				>
					<span>{{ $t("views.AccessOption.copyright") }}</span>
					<LogoHuddle></LogoHuddle>
				</div>
			</div>
			<alert-error
				:textError="messageErrorLogin"
				:nameButton="buttonText"
				action="try-again"
				v-if="errorLogin"
			></alert-error>
			<loader
				v-if="isLoading"
				loaderStyle="circle"
				:loaderMessage="$t('components.FormLogin.loader')"
			></loader>
		</div>
		<!-- <title-login title="Login"></title-login> -->

	</div>
</template>
<script>
/* eslint-disable */
import ButtonFacebook from "./Buttons/ButtonFacebook";
import LogoRepense from "./customIcons/logoRepense.vue";
import logoDecode from "./customIcons/logoDecode.vue";
import LogoHuddle from "./customIcons/logoHuddle.vue";
import ButtonGoogle from "./Buttons/ButtonGoogle";
import ButtonOutline from "./Buttons/ButtonOutline";
import AlertError from "./Alerts/AlertError";
import TitleLogin from "./Text/TitleLogin";
import InputDefault from "./Inputs/InputDefault";
import FooterDefault from "./Sections/FooterDefault";
import Loader from "./Alerts/Loader";
import authService from "../api/authentication";
// import authFirebase from "../helpers/authFirebase"
import Bus from "@/main.js";

export default {
	data() {
		return {
			errorLogin: false,
			resetPass: false,
			messageErrorLogin: "",
			buttonText: "",
			isLoading: false,
			workspaceId: "",
			workspaceTitle: "",
			colors: {},
			noRegisterWorkspaces: ["sPCGDV1ja9639qzApX3E","ffocEYR9N4uxEDkGodO6","Oj6FEicMCYo4wCoFMSOq", "eBHsVn7mliHvdn7HpQ2w", "FQXA54XWkOIrdBdULMVk", "VhqgBeprpg5qe7u1wuB5","5KNimvGHpXAXJPCDQPE4", "2gjlFIwIVp7ETRhwRW5D", "hhUQOtfUdp48zA99vOXy","LX0x6uEQL8yBtn1DIDMt", "FleGP9zl82X5rdwY58FQ", "lBW2RdHCia5QiqX5a3qs"]
		};
	},
	components: {
		LogoRepense,
		logoDecode,
		LogoHuddle,
		ButtonFacebook,
		ButtonGoogle,
		TitleLogin,
		ButtonOutline,
		InputDefault,
		FooterDefault,
		AlertError,
		Loader
	},
	created() {
		Bus.$on("try-again", this.tryAgain);
		this.workspaceId = localStorage.getItem("workspaceId");
		this.workspaceTitle = localStorage.getItem("workspaceTitle");
		this.colors = JSON.parse(localStorage.getItem("colors"));
		this.game = localStorage.getItem("game-redirect");
	},
	destroyed() {
		Bus.$off("try-again", this.tryAgain);
	},
	methods: {
		tryAgain() {
			this.errorLogin = false;
			password.value = "";
			this.resetPass == true ? password.focus() : email.focus();
		},
		async loginEmailPassword() {
			// this.actionButton("email");
			let self = this;
			self.isLoading = true;
			if (email.value == "" || password.value == "") {
				self.errorLogin = true;
				self.messageErrorLogin = self.$t("components.FormLogin.messagesError[0].message");
				self.buttonText = self.$t("components.FormLogin.messagesError[0].buttonText");
				return self.isLoading = false;
			}
			
			const userReq = await authService.post(`/users`, {
				newUser: false,
				email: email.value.replaceAll(" ", "").toLowerCase(),
				password: password.value
			})
			if(userReq.data.response != "user successfully authenticated" && userReq.data.authResponse != "user successfully authenticated") return this.showAuthError(userReq.data.response || userReq.data.authResponse)
			let token = ''
			if(userReq.data.fields.password) delete userReq.data.fields.password
			delete userReq.data.fields.newUser 
			userReq.data.token ? token = userReq.data.token : token = userReq.data.authUser.stsTokenManager.accessToken

			this.redirectSignedUser(userReq.data.fields, token)
		},
		actionButton(type) {
			if (type == "email") {
				let loginButton = document.querySelector(".login-button");
				loginButton.classList.add("button-action-start");
				setTimeout(function() {
					loginButton.classList.remove("button-action-start");
					loginButton.classList.add("button-action-finish");
				}, 200);
			}
		},
		async getFirebaseUserCpf(uid){
			try {
				const userReq = await authService.get(`/users/${uid}`)
				return userReq.data.cpf
			}
			 catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("error trying to get CPF: ", error)
			}
		},
		redirectSignedUser(user, token){
			localStorage.setItem("user", JSON.stringify(user));
			localStorage.setItem("token", token);
			this.$router.replace("middleware-game");
		},
		showAuthError(errorDescription){
			//TODO: make a error message showing up instead console.log error
			// console.log("errorDescription: ", errorDescription)
			let self = this
			if (errorDescription == "auth/user-not-found") {
				self.messageErrorLogin = self.$t("components.FormLogin.messagesError[1].message");
				self.buttonText = self.$t("components.FormLogin.messagesError[1].buttonText");
				self.errorLogin = true;
				self.isLoading = false;
				return
			}
			if (errorDescription == "auth/wrong-password") {
				self.messageErrorLogin = self.$t("components.FormLogin.messagesError[2].message");
				self.buttonText = self.$t("components.FormLogin.messagesError[2].buttonText");
				self.errorLogin = true;
				self.isLoading = false;
				self.resetPass = true;
				return
			}
			if (errorDescription == "auth/invalid-email") {
				self.messageErrorLogin = self.$t( "components.FormLogin.messagesError[3].message" );
				self.buttonText = self.$t( "components.FormLogin.messagesError[3].buttonText" );
				self.errorLogin = true;
				self.isLoading = false;
				return
			}
			if (errorDescription == "invalid email and/or password") {
				self.messageErrorLogin = self.$t( "components.FormLogin.messagesError[5].message" );
				self.buttonText = self.$t( "components.FormLogin.messagesError[5].buttonText" );
				self.errorLogin = true;
				self.isLoading = false;
				return
			}
			self.messageErrorLogin = self.$t("components.FormLogin.messagesError[4].message");
			self.buttonText = self.$t("components.FormLogin.messagesError[4].buttonText");
			self.errorLogin = true;
			self.isLoading = false;
		}
	},
	computed:{
		image() {
			if (this.game != "repense" || this.game != 'localhost:8080') return require(`../assets/${this.game}-logo.png`);
		},		
		removeBgbyWindowSize(){
			const nobg = {
				'background': `linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			const bg = {
				'background': `url(/img/background-${this.colors.theme}.png), linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			return window.outerWidth >= 720 ? nobg : bg
		}	
	}
};
</script>
<style lang="scss" scoped>
.login-container {
	// min-height: calc(100vh - 110px);
	// max-height: calc(100vh - 60px);
	width: 100%;
	background-size: cover !important;
	.bar{
		height: 2vh;
	}
	.wrapper{
		height: 98vh;
	    display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0 32px;

		.logo {
			display: flex;
			align-items: center;

			img {
				max-width: 135px;
			}
			.svg-logo {
				width: 220px;
			}
			.center-flex{
				display: flex;
				align-items: center;
				justify-content: center;

				.svg-logo-huddle{
					width: 25%;
				}
			}
		}	
		.program_info {
			margin: 5% 0;
			text-align: center;

			.slogan {
				font-weight: 600;
			}
		}
		.container-button {
			width: 100%;
			margin-top: 8%;
			display: flex;
			justify-content: center;

			a{
				width: 80%;
				display: flex;
				justify-content: center;		
				text-decoration: none;		
			}
		}
		.button-default {
			background-color: #fbf872;
			width: 85%;
			border: none;
			padding: 18px 0 23px;
			letter-spacing: 3px;
			text-transform: uppercase;
			font-weight: bold;
			font-size: 13px;
			color: #30353a;
			border-top: 7px #fbf872 solid;
			border-bottom: 7px #d8d365 solid;
			outline: none;
			border-radius: 50px;
		}
		.button-default.secondary{
			background-color: transparent;
			border-top: none;
			border-bottom: none;
			padding: 13px 0;
		}
		.button-action-start {
			padding: 15px 0 10px;
			border-top: 7px white solid;
			border-bottom: 7px #fbf872 solid;
		}

		.button-actions-finish {
			padding: 10px 0 15px;
			border-top: 7px #fbf872 solid;
			border-bottom: 7px #d8d365 solid;
		}		
		.copyright {
			margin: 40px 0 0 0;
			display: flex;
			flex-direction: column;
			align-items: center;

			span {
				letter-spacing: 2px;
				font-size: 12px;
				padding: 0 0 15px 0;
				text-transform: uppercase;
			}

			img,
			svg {
				max-width: 85px;
			}
		}				

	}
	.cadastro {
		display: flex;
		justify-content: center;
		margin-top: 10%;
	}

	.cadastro.hidden {
		visibility: hidden;
	}

	.methods-login {
		width: 85%;
		margin: 0 auto;

		.form-login-email {
			width: 100%;

			.form {
				display: flex;
				flex-direction: column;

			}
		}

		.esqueci-senha {
			display: flex;
			justify-content: center;
			margin-top: 8%;
		}

		.login-social {
			display: flex;
			justify-content: space-between;
			margin-top: 8%;
		}
	}
}

@media only screen and (min-width: 600px) {
	.login-container {
		.methods-login {
			width: 65%;
		}
	}
}

@media only screen and (min-width: 800px) {
	.login-container {
		.methods-login {
			width: 400px;
		}
	}
}
</style>